/* eslint-disable no-void */
/* eslint-disable linebreak-style */
// React
import React from 'react';

// Redux
import { useSelector } from 'react-redux';
import { persistStore } from 'aurora-composition/actions/auroraUiActions';

// utils
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// React Router Dom
// import { Link as RouterLink } from 'react-router-dom';

// Components
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import messages from 'aurora-translations';

import ADGMImage from '../ADGMImage';
// Styles
import styles from './styles';
import { keyEmptyCheck } from '../../utils/utils';

function Footer({ classes, history }) {
  const { locale } = useSelector(state => state.language);
  const handleLocalToggle = value => {
    if (value === locale) return;
    persistStore(value);
  };
  const appointmentHandler = () => {
    window.open(
      'https://forms.office.com/Pages/ResponsePage.aspx?id=4USxjGDuo02E57afhTdhhK_X4DQpJshMk8cXEgTRBipUMTFCRDM2UVExQVRNVVVSN1Q4RDY3TFBJRC4u',
      '_blank',
    );
  };
  const isProduction = process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com';
  return (
    <footer className={classes.mainFooter}>
      <Container>
        <Grid container className={classes.borderBottom}>
          {' '}
          {/* Give border bottom */}
          <Grid item xs={12} md={3}>
            <div className={classes.logoContainer}>
              <ADGMImage name='adgm-logo-white.svg' alt='ADGM Logo' className={classes.ADGMLogo} />
            </div>
          </Grid>
          <Hidden mdUp>
            <Grid xs={12} className={[classes.borderTop, classes.borderBottom]}>
              <div className={classes.VerifiyBtnHolder}>
                <Button
                  variant='outlined'
                  color='primary'
                  className={classes.VerifyBtn}
                  onClick={() => {
                    history.push({
                      pathname: `/app/verify-documents`,
                      state: locale,
                    });
                    // CleverTapVerifyTenancyContract();
                  }}
                >
                  <ADGMImage name='document_blue.svg' alt='verify contract' style={{ margin: '5px' }} />
                  {keyEmptyCheck('document_verification')}
                  &nbsp;
                </Button>
              </div>
            </Grid>
          </Hidden>
          <Hidden mdUp>
            <Grid xs={12} className={[classes.borderTop, classes.borderBottom]}>
              <div className={classes.VerifiyBtnHolder}>
                <Button variant='outlined' color='primary' className={classes.VerifyBtn} onClick={appointmentHandler}>
                  <ADGMImage name='appointment_blue.svg' alt='verify contract' style={{ margin: '5px' }} />
                  {keyEmptyCheck('schedule_appointment')}
                  &nbsp;
                </Button>
              </div>
            </Grid>
          </Hidden>
          <Grid item xs={12} md={6}>
            <Grid container justifyContent='space-between' spacing={1} className={classes.lists}>
              {/* Company */}
              <Grid item xs={12} sm={6} md={2}>
                <Typography variant='subtitle1' className={classes.title}>
                  {keyEmptyCheck('company_homepage')}
                </Typography>
                <List component='nav' className={classes.navList}>
                  <a target='_blank' href='https://www.adgm.com/about/overview' rel='noreferrer'>
                    <ListItemText primary={keyEmptyCheck('about_dari')} />
                  </a>
                  {/* <a href='href={void 0}' target='_blank' rel='noopener noreferrer'>
                    <ListItemText primary={keyEmptyCheck('become_a_partner')} />
                  </a> */}
                  {/* <RouterLink to=''>
                    <ListItemText primary={keyEmptyCheck('terms_conditions')} />
                  </RouterLink> */}
                  <a target='_blank' href='https://www.adgm.com/information/privacy-policy' rel='noreferrer'>
                    <ListItemText primary={keyEmptyCheck('Privacy_policy')} />
                  </a>
                  <a target='_blank' href='https://www.adgm.com/contact-us/make-enquiry' rel='noreferrer'>
                    <ListItemText primary={<FormattedMessage {...messages.Contact_us} />} />
                  </a>
                </List>
              </Grid>

              {/* Support */}
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant='subtitle1' className={classes.title}>
                  {keyEmptyCheck('dari_support')}
                </Typography>
                <List component='nav' className={classes.navList}>
                  <ListItem component='a'>
                    <ListItemText primary={<a href='mailto:accessrp.support@adgm.com'>accessrp.support@adgm.com</a>} />
                  </ListItem>
                  <ListItem component='a'>
                    <ListItemText primary={<a href='tel:023338888'>02 333 8888</a>} />
                  </ListItem>
                </List>
              </Grid>

              {/* Langugge */}
              <Grid item xs={12} sm={6} md={2}>
                <Typography variant='subtitle1' className={classes.title}>
                  {keyEmptyCheck('Languages')}
                </Typography>
                <List component='nav' className={classes.navList}>
                  {!isProduction && (
                    <ListItem
                      component='a'
                      onClick={() => {
                        handleLocalToggle('ar');
                      }}
                    >
                      <span className={classes.title_ar}>{keyEmptyCheck('arabic')}</span>
                    </ListItem>
                  )}
                  <ListItem
                    component='a'
                    onClick={() => {
                      handleLocalToggle('en');
                    }}
                  >
                    <ListItemText primary={<FormattedMessage {...messages.english} />} />
                  </ListItem>
                </List>
              </Grid>

              {/* Feedback */}
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant='subtitle1' className={classes.title}>
                  {keyEmptyCheck('have_any_feedback')}
                </Typography>
                <List component='nav' className={classes.navList}>
                  <ListItem
                    onClick={() => {
                      history.push({
                        pathname: `/app/feedback`,
                        state: { locale, resetFeedback: true },
                      });
                    }}
                    style={{
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                  >
                    <span className={classes.feedback}>
                      {keyEmptyCheck('love_to_hear')}
                      <img
                        src='/images/rs-arrow-right.svg'
                        alt=''
                        style={{
                          marginLeft: '6px',
                          marginTop: '2px',
                          marginRight: '6px',
                          transform: locale === 'ar' ? 'scaleX(-1)' : 'none',
                        }}
                      />
                    </span>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
          <Hidden smDown>
            <Grid item xs={12} md={3}>
              <Grid container spacing={1} alignItems='center'>
                <Grid item xs={12} className={[classes.full_width, classes.mt10]}>
                  <div className={classes.VerifiyBtnHolder}>
                    <Button
                      variant='outlined'
                      color='primary'
                      className={classes.VerifyBtn}
                      onClick={appointmentHandler}
                    >
                      <ADGMImage
                        src='/images/appointment_blue.svg'
                        alt='verify contract'
                        style={{ margin: '5px', width: '12px', height: '14px' }}
                      />
                      {keyEmptyCheck('schedule_appointment')}
                      &nbsp;
                    </Button>
                  </div>
                </Grid>

                {/* Verifiy Contract */}
                <Grid item xs={12} className={[classes.full_width, classes.mt10]}>
                  <div className={classes.VerifiyBtnHolder}>
                    <Button
                      variant='outlined'
                      color='primary'
                      className={classes.VerifyBtn}
                      onClick={() => {
                        history.push({
                          pathname: `/app/verify-documents`,
                          state: locale,
                        });
                        // CleverTapVerifyTenancyContract();
                      }}
                    >
                      <ADGMImage
                        src='/images/document_blue.svg'
                        alt='verify contract'
                        style={{ margin: '5px', width: '14px', height: '14px' }}
                      />
                      {keyEmptyCheck('document_verification')}
                      &nbsp;
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
        </Grid>
        <Grid container className={[classes.padding10, classes.lastFooter]}>
          <Grid item xs={12} sm={6} className={[classes.footerMargin]}>
            <Typography variant='body1'>{keyEmptyCheck('footer_title')}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.socialMedia}>
            <div className={classes.followUs}>{keyEmptyCheck('follow_us_on')} :</div>
            <div className={classes.socialMediaIcons}>
              <a href='https://www.linkedin.com/company/adgm/' target='_blank' rel='noopener noreferrer'>
                <ADGMImage name='linkdinIcon.svg' alt='linkdin' className={classes.logoSize} />
              </a>
              <a href='https://x.com/adglobalmarket' target='_blank' rel='noopener noreferrer'>
                <ADGMImage name='exSocial.svg' alt='twitter' className={classes.logoSize} />
              </a>
              <a href='https://www.youtube.com/@ADGM' target='_blank' rel='noopener noreferrer'>
                <ADGMImage name='youtubeIcon.svg' alt='youtube' className={classes.logoSize} />
              </a>
              <a href='https://www.instagram.com/adgm/' target='_blank' rel='noopener noreferrer'>
                <ADGMImage name='instagram.svg' alt='instagram' className={classes.logoSize} />
              </a>
            </div>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
